
import request from '../request';
import qs from 'qs';
// 保险福利列表
const getEntitlementList = function (data) {
  return request.post('/api/wx/auth/benefit/getEntitlementList', data)
}
// .保险福利详情
const getEntitlementDetail = function (data) {
  return request.post(`/api/wx/auth/benefit/getEntitlementDetail?${qs.stringify(data)}`)
}
// 保险责任详情
const getCoverageList = function (data) {
  return request.post(`/api/wx/auth/benefit/getCoverageList?${qs.stringify(data)}`)
}
// 显示责任下福利
const getbenList = function (data) {
  return request.post(`/api/wx/auth/benefit/getbenList?${qs.stringify(data)}`)
}
// 保险条款文档列表
const getPlanDocList = function (data) {
  return request.post(`/api/wx/auth/benefit/getPlanDocList?${qs.stringify(data)}`)
}
// 保险条款文档内容
const getPlanDocDetail = function (data) {
  return request.get(`/api/wx/benefit/getPlanDocDetail?${qs.stringify(data)}`, { responseType: 'blob' })
}
// 福利列表
const getWxBenefitList = (data) => {
  return request.post('/api/wx/auth/getWxBenefitList', data)
}
// 责任列表
const getWxCoverageList = (data) => {
  return request.post('/api/wx/auth/getWxCoverageList', data)
}
// 共享限制列表
const getSharedLimits = (data) => {
  return request.post('/api/wx/auth/getSharedLimits', data)
}
  // 对象数组
export default {
	getEntitlementList,
	getEntitlementDetail,
	getCoverageList,
	getbenList,
	getPlanDocList,
	getPlanDocDetail,
	getWxBenefitList,
	getWxCoverageList,
	getSharedLimits
};